import {
    submitContactUsForm,
    SubmitContactUsFormApiParameter,
} from "@crescentParts/Services/SubmitContactUsFormService";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess &
    HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter, any>;

const CustomPopulateApiParameter: CustomHandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        FirstName: state.fieldValues["firstName"],
        LastName: state.fieldValues["lastName"],
        Phone: state.fieldValues["phoneNumber"],
        CompanyName: state.fieldValues["CompanyName"],
        BusinessType: state.fieldValues["BusinessType"],
        Website: state.fieldValues["WebsiteUrl"],
        Email: state.fieldValues["emailAddress"],
        ReasonForContact: state.fieldValues["topic"],
        Message: state.fieldValues["message"],
        emailTo: props.parameter.emailRecipients,
    };
};

const CustomSendDataToApi: CustomHandlerType = async props => {
    try {
        const result = await submitContactUsForm(props.apiParameter);
        props.apiResult = {
            success: true,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
        };
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (!props.apiResult.success) {
        props.parameter.onError?.();
    }
};

export const chain = [
    CustomPopulateApiParameter,
    CustomSendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
